import React, { useEffect, useRef, useState } from "react";

import Icon from "../../../../components/Icon";
import InputDate from "../../../../components/InputDate";
import Button from "../../../../components/Button";
import { PERIOD_PRESETS, getPeriodLabel, resolvePeriod, shiftPeriod } from "../periods";

/**
 * Seletor de período das telas do financeiro: setas que andam uma unidade do
 * período escolhido, atalhos e intervalo personalizado. Recebe e devolve
 * `{ preset, start, end }`.
 */
export const PeriodNavigator = ({ value, onChange }) => {
    const [open, setOpen] = useState(false);
    const [customStart, setCustomStart] = useState('');
    const [customEnd, setCustomEnd] = useState('');
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = event => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (!open) return;

        setCustomStart(value.start || '');
        setCustomEnd(value.end || '');
    }, [open]);

    const choose = preset => {
        onChange(resolvePeriod(preset));
        setOpen(false);
    };

    const applyCustom = () => {
        onChange({ preset: 'custom', start: customStart, end: customEnd });
        setOpen(false);
    };

    const canShift = value.preset !== 'all' && !!value.start && !!value.end;
    const customIsValid = !!customStart && !!customEnd && customStart <= customEnd;

    return (
        <div className={`finance-period-navigator`} ref={containerRef}>
            <button type="button" className="period-step" onClick={() => onChange(shiftPeriod(value, -1))} disabled={!canShift} aria-label="Período anterior">
                <Icon name="arrow-left" size={18} />
            </button>
            <button type="button" className={`period-label${open ? ' open' : ''}`} onClick={() => setOpen(!open)}>
                {getPeriodLabel(value)}
                <Icon name="arrow-dropdown" size={16} />
            </button>
            <button type="button" className="period-step" onClick={() => onChange(shiftPeriod(value, 1))} disabled={!canShift} aria-label="Próximo período">
                <Icon name="arrow" size={18} />
            </button>

            {open &&
                <div className="period-menu">
                    {PERIOD_PRESETS.map(preset => (
                        <button
                            type="button"
                            key={preset.value}
                            className={`period-option${value.preset === preset.value ? ' active' : ''}`}
                            onClick={() => choose(preset.value)}
                        >
                            {preset.label}
                        </button>
                    ))}
                    <div className={`period-custom${value.preset === 'custom' ? ' active' : ''}`}>
                        <span>Período personalizado</span>
                        <div className="period-custom-dates">
                            <InputDate label={`De`} format={`YYYY-MM-DD`} value={customStart} change={setCustomStart} />
                            <InputDate label={`Até`} format={`YYYY-MM-DD`} value={customEnd} change={setCustomEnd} />
                        </div>
                        <Button type={`secondary`} size={`small`} full={true} text={`Aplicar`} action={applyCustom} disabled={!customIsValid} />
                    </div>
                </div>
            }
        </div>
    );
};

export default PeriodNavigator;
